import { IUser } from "models/IUser";
import { CustomOption } from "components/fields/peoplePicker/PeoplePicker.types";
import { mapAzureUserToModel } from "utils/generalUtils";

/**
 * Converts user IDs to CustomOption objects using Redux user data
 * @param userIds - Array of user IDs to map
 * @param users - Array of IUser objects to search in
 * @returns Array of CustomOption objects
 */
export const getPreselectedUsers = (
  userIds: string[],
  users: IUser[],
): CustomOption[] => {
  return userIds
    .map((id: string) => {
      const user: IUser | undefined = users.find((u: IUser) => u.id === id);
      return user ? mapAzureUserToModel(user) : undefined;
    })
    .filter((user): user is CustomOption => !!user);
};

/**
 * Validates field character count and returns validation message and state
 * @param length - Current character count
 * @param maxLength - Maximum allowed characters
 * @param warningThreshold - Character count threshold before showing warning
 * @returns Object with validation message and state (error, warning, or none)
 */
export const getFieldValidation = (
  length: number,
  maxLength: number,
  warningThreshold: number,
): { message: string | undefined; state: "error" | "warning" | "none" } => {
  if (length > maxLength) {
    return { message: `${length}/${maxLength} characters`, state: "error" };
  }
  if (length >= warningThreshold) {
    return { message: `${length}/${maxLength} characters`, state: "warning" };
  }
  return { message: undefined, state: "none" };
};
